<template>
  <div>
    <router-view />
  </div>
</template>

<script>
export default {
  name: "FullSite",
  components: {}
};
</script>

<style></style>
